import React from "react";

interface LandMarkSVGProps {
    color: string
}

const LandMarkSVG: React.FC<LandMarkSVGProps> = ({color}) => {
    return (
        <svg
            width="100%"
            viewBox="0 0 62.406532 227.68324"
            version="1.1"
            id="svg1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs
                id="defs1"/>
            <g
                id="layer1"
                transform="translate(-126.59485,-22.005892)">
                <g
                    id="g6">
                    <path
                        style={{
                            color: color,
                            fill: color,
                            strokeLinecap: 'round',
                            strokeDasharray: '5, 10',
                            strokeWidth: 7,
                        }}
                        d="m 157.79811,79.984375 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 5.000005 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5.000005 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15.000005 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 4.99999 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -4.99999 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,14.99999 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z m 0,15 a 2.5,2.5 0 0 0 -2.5,2.5 v 5 a 2.5,2.5 0 0 0 2.5,2.5 2.5,2.5 0 0 0 2.5,-2.5 v -5 a 2.5,2.5 0 0 0 -2.5,-2.5 z"
                        id="path2"/>
                    <path
                        id="path3"
                        style={{
                            color: color,
                            fill: color,
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeWidth: 7,
                            paintOrder: 'markers stroke fill'
                        }}
                        d="m 157.79709,22.005892 c -16.86624,0 -30.59194,13.727247 -30.59194,30.593481 0,16.866235 13.7257,30.591932 30.59194,30.591932 16.86623,0 30.59399,-13.725697 30.59399,-30.591932 0,-16.866234 -13.72776,-30.593481 -30.59399,-30.593481 z m 0,5.000212 c 6.17886,0 11.83645,2.175978 16.25275,5.804296 L 157.79657,49.063672 141.54381,32.810917 c 4.41606,-3.628904 10.07386,-5.804813 16.25328,-5.804813 z m 19.78897,9.339481 c 3.62875,4.416429 5.80481,10.074519 5.80481,16.253788 0,6.179411 -2.17591,11.837735 -5.80481,16.253789 L 161.33227,52.599373 Z m -39.57743,0.0016 16.25224,16.252238 -16.25224,16.252238 c -3.62778,-4.415845 -5.80326,-10.073491 -5.80326,-16.252238 0,-6.178605 2.17563,-11.836017 5.80326,-16.252238 z m 19.78794,19.78794 16.25327,16.253271 c -4.41626,3.627773 -10.07401,5.803264 -16.25275,5.803264 -6.17927,0 -11.83675,-2.175972 -16.25276,-5.804297 z"/>
                    <path
                        id="rect5"
                        style={{
                            color: color,
                            fill: color,
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeWidth: 7,
                            paintOrder: 'markers stroke fill'
                        }}
                        d="m 157.7976,223.03442 c -2.8067,3.5e-4 -5.61366,1.06562 -7.7432,3.19516 l -23.45955,23.45955 h 7.07089 l 19.92437,-19.92385 c 2.36154,-2.36154 6.05293,-2.36309 8.41448,-0.002 l 19.92539,19.9254 h 7.0714 l -23.46109,-23.4611 c -2.12954,-2.12954 -4.93598,-3.19395 -7.74269,-3.19361 z"/>
                </g>
            </g>
        </svg>
    )
}

export default LandMarkSVG;